<template>
	<div
		v-infinite-scroll="loadMore"
		infinite-scroll-disabled="loading"
		infinite-scroll-distance="500"
	>
		<template v-if="!(current_company === 'demo-courses' || current_company === 'soft-skills')">
			<CoursesCatalogPresetSelection
				v-if="presets.length > 0"
				:presets="presets"
				:newCourses="true"
				:current_company="current_company"
				:is_current_user="is_current_user"
			/>
		</template>

		<CoursesCatalogSelection
			v-if="!(current_company === 'mega' || current_company === 'soft-skills' || current_company === 'scorm')"
			:selection="newest_courses"
			:newCourses="true"
		/>

		<template v-if="current_company === 'soft-skills'">
			<CoursesCatalogSelection
				v-for="(preset_with_courses, index) in filtered_presets_with_courses"
				:key="'catalog-' + preset_with_courses.id + '-' + index"
				:selection="preset_with_courses"
			/>
		</template>
		<template v-else-if="current_company === 'scorm'">
			<CoursesCatalogSelection
				v-for="(selection, index) in topics"
				:key="'catalog-' + selection.id + '-' + index"
				:selection="selection"
			/>
		</template>
		<template v-else>
			<CoursesCatalogSelection
				v-for="(selection, index) in filtered_topics"
				:key="'catalog-' + selection.id + '-' + index"
				:selection="selection"
			/>
		</template>
	</div>
</template>

<script>
import CoursesCatalogPresetSelection from "./Catalog/PresetSelection.vue";
import CoursesCatalogSelection from "./Catalog/Selection.vue";
import Topic from "./Topic.vue";
import infiniteScroll from "meta-infinite-scroll";

export default {
	name: "CoursesCatalog",

	components: {
		CoursesCatalogPresetSelection,
		CoursesCatalogSelection,
		Topic,
	},

	directives: { infiniteScroll },

	props: {
		presets: Array,
		topics: Array,
		newest_courses: Object,
		current_company: {
			type: String,
			default: ''
		},
		is_current_user: {
			type: Boolean,
			default: true
		},
		presets_with_courses: {
			type: Array,
			default: [],
			required: false
		}
	},

	data() {
		return {
			data: [],
			сoursesCatalogName: "",
			loading: false,
			currentPage: 1,
			count: 2,
		};
	},

	computed: {
		filtered_topics() {
			return this.topics
				.filter((i) => i.courses.length > 5)
				.sort((a, b) => b.count - a.count)
				.slice(0, this.count);
		},

		filtered_presets_with_courses() {
			return this.topics
				.slice(0, this.count);
		}
	},

	methods: {
		loadMore: function() {
			this.loading = true;

			setTimeout(() => {
				this.count += 3;
				this.loading = false;
			}, 50);
		},
	},
};
</script>
